

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var targetClassName =
	{
		install:"js-btn-install",
		startup:"js-btn-startup"
	}

	var wrapperButtonClassName = "js-app-btn" ;
	var wrapperQRClassName = "js-app-qr" ;

	// サイトを判別する文字列を入れてください
	var campaign = location.pathname ;

	var SettingURLData =
	{
		install_ios:"https://vwb-6.tlnk.io/serve?action=click&amp;publisher_id=346166&amp;site_id=74816&amp;offer_id=426855",
		install_android:"https://lyl-s.tlnk.io/serve?action=click&amp;publisher_id=346166&amp;site_id=74814&amp;offer_id=426854",
		install_apk:"https://www.monster-strike.com.tw/download/apk_download.html", //データは持っているど、現状このjs内では利用していない
		startup:"monsterstrike-tw-app://"
	}


//------------------------------------------------------------------------------------------------------------------------------


	var AppButton = function( )
	{
		var _this = this , i , temp ;
		var btns ;


		//


		var ua = navigator.userAgent.toLowerCase( ) ;
		var isIOS = /iphone;|ipad;|ipod;/.test(ua) ;
		var isAndrtoid = /android/.test(ua) ;
		var androidVersion = isAndrtoid ? parseFloat( ua.slice(ua.indexOf("android")+8) ) : 0 ;

		var device = 	isIOS ? "ios" :
						isAndrtoid ? "android" : "pc" ;

		// PCだった場合リンクの設定処理を行わない
		//
		if( device == "pc" )
		{
			var hiddenTarget = document.getElementsByClassName( wrapperButtonClassName ) ;
			for( i = 0 ; i < hiddenTarget.length ; i++ )
			{
				hiddenTarget[i].style.display = "none" ;
			}
			return ;
		}else {
			var hiddenTarget = document.getElementsByClassName( wrapperQRClassName ) ;
			for( i = 0 ; i < hiddenTarget.length ; i++ )
			{
				hiddenTarget[i].style.display = "none" ;
			}
		}



		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


		var query = getQuery( ) ;
		if( query.utm_source )	sessionStorage.utm_source = encodeURIComponent( query.utm_source ) ;

		if( sessionStorage.utm_source )
		{
			temp = sessionStorage.utm_source ;
			SettingURLData.startup = SettingURLData.startup + temp ;
			SettingURLData.install_ios = SettingURLData.install_ios + temp ;
			SettingURLData.install_android = SettingURLData.install_android + temp ;
			SettingURLData.install_apk = SettingURLData.install_apk + temp ;
		}


		// bypassリテンション広告用の記述
		var REG_bypass = /bypass/g ;
		if( REG_bypass.test( location.search ) )
		{
			temp = location.search.split( "bypass" )[1] ;
			SettingURLData.startup = SettingURLData.startup + temp ;
			SettingURLData.install_ios = SettingURLData.install_ios + temp ;
			SettingURLData.install_android = SettingURLData.install_android + temp ;
			SettingURLData.install_apk = SettingURLData.install_apk + temp ;
		}

		//


		// Android5.0系以上のchrome以外のブラウザ（webview製のブラウザ）からストア起動ができない問題の対策
		if( androidVersion >= 5 && /; wv/.test(ua) )
		{
			SettingURLData.install = "https://lyl-s.tlnk.io/serve?action=click&amp;publisher_id=346166&amp;site_id=74814&amp;offer_id=426854" ;
		}


		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


		// ストア起動ボタンの実装
		btns = document.getElementsByClassName( targetClassName.install ) ;
		for( i = 0 ; i < btns.length ; i++ )
		{
			btns[i].href = isAndrtoid ? SettingURLData.install_android :
										SettingURLData.install_ios ;
		}


		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -


		// アプリ起動ボタンの実装
		btns = document.getElementsByClassName( targetClassName.startup ) ;
		for( i = 0 ; i < btns.length ; i++ )
		{
			btns[i].href = SettingURLData.startup ;
		}
	}


//------------------------------------------------------------------------------------------------------------------------------


	var getQuery = function( )
	{
		var obj = {} ;
		var value ;
		var i ;

		var query = window.location.search.slice(1).split( "&" ) ;

		for( i in query )
		{
			value = query[ i ].split("=") ;

			if( value.length != 2 )	 value.push( null ) ;

			obj[ value[0] ] = value[1] ;
		}

		return obj ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	// DOMの準備が完了したら実行
	document.readyState === "complete"
		? setTimeout( function(){ new AppButton( ); } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new AppButton( ); } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;

